import React, { useEffect, useState } from "react";

import { connect, useDispatch, useSelector } from "react-redux";
import { Table, Tag } from "antd";
import ReactStars from "react-stars";
// import "antd/dist/antd.css";
// import { itemRender, onShowSizeChange } from "../../paginationfunction";

import { Link } from "react-router-dom";
import { EditInfo, DeleteModal } from ".";
import { apiURL } from "../../utils/config";
// import { getCourseOwners } from "../../appRedux/actions/courseOwners";
import { Avatar_02 } from "../../Routes/ImagePath";
import moment from "moment";
import { currencyConverter } from "../../utils/currency";
import { getStaffsList } from "../../appRedux/actions/staffs";



function ListView({searchText}) {
  const dispatch = useDispatch();
  const [list,setList]= useState([])
  const { staffList} = useSelector(
    (state) => ({
      staffList: state.staffs.staffList,
      queryInfo: state.staffs.queryInfo,
      totalRecords: state.staffs.totalRecords,
      selectedCurrency: state.common.selectedCurrency,
      currencyData: state.common.currencyData,
    })
  );

  useEffect(() => {
    console.log({searchText})
    if (searchText) {
      const filteredList = staffList.filter(staff =>
        staff.name.toLowerCase().includes(searchText.toLowerCase())
      );
      setList(filteredList);
    } else {
      setList(staffList);
    }
  }, [searchText, staffList]);

    
  useEffect(()=>{setList(staffList)},[staffList])

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (name, record) => (
        <h2 className="table-avatar" style={{ textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          <Link to={``} className="avatar">
            <img
              alt=""
              src={record.imageurl ? record.imageurl : record.image ? record.image : Avatar_02}
            />
          </Link>
          {name}
        </h2>
      ),
      // width: "30px",
      // sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Email Id",
      dataIndex: "email",
      align: "center",
      render: (email, record) => (
        <h2 className="table-avatar" style={{ textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {email}
        </h2>
      ),
    },
    {
      title: "Contact No.",
      dataIndex: "contactNo",
      align: "center",
    },

    {
      title: "Verified",
      dataIndex: "verified",
      align: "center",
      render: (verified, record) => (
        <div className="dropdown">
          <Link
            to={""}
            className={`btn btn-white btn-sm btn-rounded  ${
              verified ? (record.googleId ? "px-2" : "px-3") : ""
            } `}
            style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: "60px" }}
          >
            <i className={`far fa-dot-circle ${verified ? "text-success" : "text-danger"} `} />
            {verified ? (record.googleId ? "Google" : "Email") : "Unverified"}
          </Link>
        </div>
      ),
    },
    {
      title: "Action",
      align: "center",
      // fixed: "right",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-center" style={{ padding: "8px" }}>
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <DeleteModal info={record} />
          </div>
        </div>
      ),
    },
  ];

  const itemRender = (_, type, originalElement) => {
    console.log(type, "a", originalElement);
    // if (type === "prev") {
    //   return (
    //     <i
    //       class="fa fa-angle-double-left"
    //       data-bs-toggle="tooltip"
    //       title="fa fa-angle-double-left"
    //     ></i>
    //   );
    // }
    // if (type === "next") {
    //   return (
    //     <i
    //       class="fa fa-angle-double-right"
    //       data-bs-toggle="tooltip"
    //       title="fa fa-angle-double-right"
    //     ></i>
    //   );
    // }
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return originalElement;
  };
  return (
    <div className="row m-0 mt-3">
      <div className="col-md-12 p-0" id="table-responsive">
        <div className="table-responsive" id="setMinheight">
          <Table
            className="table-striped"
            pagination={true}
            // pagination={{
            //   total: totalRecords,
            //   pageSizeOptions: ["5", "10", "20", "50"],
            //   showSizeChanger: true,
            //   showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
            //   onShowSizeChange: (current, pageSize) => {
            //     console.log({ current, pageSize });
            //     dispatch(
            //       getStaffsList({
            //         ...queryInfo,
            //         page: current,
            //         size: pageSize,
            //       })
            //     );
            //   }, //onShowSizeChange,
            //   itemRender: itemRender,
            // }}
            // onChange={(pagination, filters, sorter) =>
            //   handleTableChange(pagination, filters, sorter)
            // }
            style={{ overflowX: "auto" }}
            columns={columns}
            // bordered
            dataSource={list}
            rowKey={(record) => record.id}
            // onChange={this.handleTableChange}
          />
        </div>
      </div>
    </div>
  );
}

export default ListView;
